import { t } from '!/i18n'
import { type Route } from '!/router'
import { keys } from '@/jail'
import { Footer } from '~/shared/ui/components/Footer'
import { NavBar } from '~/widgets/NavBar'
import * as expired from './expired'
import * as fail from './fail'
import * as geoblock from './geoblock'
import * as logout from './logout'
import * as signin from './sign-in'
import * as toa from './toa'
import * as verify from './verify'

export default {
  keys: [keys.sign, keys.guest],

  children: [
    {
      path: ['/sign-in/verify', '/sign-up/verify'],
      title: () => t('account_verify'),
      init: verify.authVerifyModel.init,
      component: verify.VerifyPage,
    },
    {
      path: '/sign-in(.*)',
      title: () => t('sign_in'),
      init: signin.model.init,
      left: signin.model.left,
      component: signin.SignInPage,
    },
    {
      keys: [keys.toa],
      path: '/toa(.*)',
      title: () => t('terms_of_agreements'),
      component: toa.ToaPage,
      init: toa.model.init,
    },
    {
      keys: [keys.expired],
      path: '/expired(.*)',
      title: () => t('expired_subscription'),
      component: [expired.ExpiredPage, Footer],
      init: expired.model.init,
    },
    {
      keys: [keys.master],
      path: '/logout(.*)',
      title: 'Logout',
      component: [NavBar, logout.LogoutPage, Footer],
      init: logout.model.init,
      left: logout.model.left,
    },
    {
      path: '/sign-up',
      load: () => import('./sign-up'),
    },
    {
      path: '/forgot-password',
      load: () => import('./forgot-password'),
    },
    {
      path: '/fail',
      title: () => t('fail'),
      component: fail.ErrorPage,
    },
    {
      keys: [keys.geoblock],
      path: '/geoblock',
      title: () => t('geoblock'),
      component: geoblock.GeoBlockPage,
    },
  ],
} satisfies Route
